// extracted by css-extract-rspack-plugin
export default {"message":"message-IOv7WJ"};